import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const StructuredData: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const baseStructuredData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "SentiHype",
      "description": "Real-time social sentiment analytics for stocks and cryptocurrencies. Monitor Reddit, Twitter, and social media sentiment before market moves.",
      "url": "https://sentihype.com",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "author": {
        "@type": "Organization",
        "name": "SentiHype",
        "url": "https://sentihype.com"
      },
      "creator": {
        "@type": "Person",
        "name": "SentiHype Developer"
      },
      "keywords": "sentiment analysis, stock sentiment, cryptocurrency sentiment, social media analytics, Reddit sentiment, market sentiment",
      "featureList": [
        "Real-time sentiment analysis",
        "Social media monitoring",
        "Stock sentiment tracking",
        "Cryptocurrency sentiment analysis",
        "Market sentiment dashboard",
        "Free sentiment analytics"
      ]
    };

    // Добавляем специфичные данные для страниц тикеров
    if (location.pathname.startsWith('/ticker/')) {
      const ticker = location.pathname.split('/')[2];
      const tickerData = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        "name": `${ticker} Stock Sentiment Data`,
        "description": `Real-time sentiment analysis data for ${ticker} stock from social media sources`,
        "keywords": `${ticker}, stock sentiment, market sentiment, social media analysis`,
        "url": `https://sentihype.com/ticker/${ticker}`,
        "creator": {
          "@type": "Organization",
          "name": "SentiHype"
        }
      };
      
      // Добавляем оба блока структурированных данных
      const script1 = document.createElement('script');
      script1.type = 'application/ld+json';
      script1.text = JSON.stringify(baseStructuredData);
      
      const script2 = document.createElement('script');
      script2.type = 'application/ld+json';
      script2.text = JSON.stringify(tickerData);
      
      document.head.appendChild(script1);
      document.head.appendChild(script2);
      
      return () => {
        document.head.removeChild(script1);
        document.head.removeChild(script2);
      };
    } else {
      // Только базовые данные для других страниц
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(baseStructuredData);
      
      document.head.appendChild(script);
      
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [location.pathname]);

  return null;
};

export default StructuredData; 
